import React, { useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

export default function CheckoutForm({redirect}) {
    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!stripe || !elements || isLoading) return;

        setIsLoading(true);
        console.log('Redirect:', redirect);
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: redirect,
            },
        });

        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsLoading(false);
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element" options={{layout: {
                type: 'tabs'
            }}} />
            <div className="w-100 mt-40 f-row f-end gap-10" disabled={isLoading || !stripe || !elements} id="submit">
                <button className="btn" style={{width: '100%', borderRadius: 60, height: 50, fontWeight: 700, fontSize: 20}}>
                    {isLoading ? (
                        <div className="loading f-row">
                            <span></span>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    ) : <>Pay Now</>
                    }
                </button>
            </div>
            {message && <div id="payment-message" style={{color: 'red', marginTop: '10px'}}>{message}</div>}
        </form>
    );
}